<mat-icon [ngClass]="element.hasNotifications ? 'blinking-bell' : 'hidden'">
  fiber_manual_record
</mat-icon>

<!-- EXPAND BUTTON -->
<button *ngIf="element.type==='diagnosis'"
        class="expand-button"
        mat-icon-button
        matTooltip="Show this diagnosis content."
        (click)="toggleDiagnosisContent(element,$event)">
  <mat-icon *ngIf="!element.expanded; else expanded">
    arrow_right
  </mat-icon>
  <ng-template #expanded>
    <mat-icon>
      arrow_drop_down
    </mat-icon>
  </ng-template>
</button>

<a download
   target="_blank"

   attr.data-storename="{{ element.storename }}"
   mat-flat-button
   matTooltip="Click here to browse the file in a new tab."

   [ngClass]="'folder-button'"
   (click)="handleFileClick($event, element)">
  <mat-icon *ngIf="element.type==='diagnosis'"
            class="material-icons-outlined"
            aria-hidden="false"
            aria-label="Diagnosis">
    personal_injury
  </mat-icon>
  {{element.fileName}}
</a>
<div *ngIf="element.expanded"
     style="margin-left:65px">
  <div *ngIf="element.medications || element.documents"
       class="diagnosis-content">
    <div>
      <mat-icon class="material-icons-outlined"
                aria-hidden="false"
                aria-label="Medication">
        vaccines
      </mat-icon>
      <b>
        Medications:
      </b>
      <span *ngFor="let content of element.medications">
        {{content.name}}
      </span>
    </div>
    <div *ngIf="element.documents">
      <mat-icon class="material-icons-outlined"
                aria-hidden="false"
                aria-label="File">
        description
      </mat-icon>
      <b>
        Documents:
      </b>
      <span *ngFor="let content of element.documents">
        {{content.name}}
      </span>
    </div>
  </div>
</div>
